import React from "react"

import { elements } from "caradvise_shared_components"
const { GenericPanel } = elements
export default GenericPanel
